import React, { useCallback, useState } from 'react';

import { useConfirm } from '@primer/react';

import CollapsibleCardView from '../../common/CardView/CollapsibleCardView';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import ModalOverlay from '../../common/ModalOverlay/ModalOverlay';
import PipelineCreationFlow from '../PipelineCreationFlow/PipelineCreationFlow';
import PipelineStepListContent from './PipelineStepListContent';
import StepIcon from '../../common/icons/StepIcon';

import { ModelSearchProvider } from '../../models/ModelSearchContext';
import { PipelineCreationProvider } from '../PipelineCreationContext';

import { usePipelineData } from '../PipelineDataContext';

export const PipelineStepListContainer = ({
  pipeline,
  items,
  error,
  onDeleteStep,
  areStepsLoading = false,
  height = 240,
}) => {
  const [isAddStepMenuOpen, setAddStepMenuOpen] = useState(false);

  const confirm = useConfirm();
  const { refetchPipelineHistory, latestPipelineDeployment } = usePipelineData();

  const handleDeleteStep = useCallback(async (stepIndex) => {
    const confirmOptions = {
      title: 'Delete Step',
      content: 'Are you sure you want to delete this pipeline step?',
      confirmButtonContent: 'Delete',
      confirmButtonType: 'danger'
    };

    if (await confirm(confirmOptions)) {
      onDeleteStep(stepIndex);
    }
  }, [confirm, onDeleteStep]);

  const cardViewProps = {
    quickActionText: '+ Add Steps',
    quickActionClick: () => setAddStepMenuOpen(true)
  }
  return (
    <div className="relative mx-0 px-0">
      {
        areStepsLoading ? (
          <LoadingSpinner animationKey="pipeline-step-list-loader" useOverlay />
        ) : null
      }
      <CollapsibleCardView
        className="flex flex-col"
        icon={StepIcon}
        headerText="Pipeline Steps"
        disabled={latestPipelineDeployment?.deployed ?? false}
        disabledText="You must undeploy this Pipeline before editing it."
        {...cardViewProps}
      >
        <PipelineStepListContent
          error={error}
          items={items}
          onDeleteStep={handleDeleteStep}
          height={height}
          deployed={latestPipelineDeployment?.deployed ?? false}
          disableScrollFading
        />
      </CollapsibleCardView>
      {
        isAddStepMenuOpen ? (
          <ModalOverlay
            animationKey="add-step-overlay"
            active={isAddStepMenuOpen}
            onModalToggle={setAddStepMenuOpen}
          >
            <div className="w-1/2 h-1/2">
              <PipelineCreationProvider pipelineToCopy={pipeline} pipelineStepsToCopy={items} pipelineRefetch={refetchPipelineHistory}>
                <ModelSearchProvider>
                  <PipelineCreationFlow startOnAdd onClose={() => setAddStepMenuOpen(false)} />
                </ModelSearchProvider>
              </PipelineCreationProvider>
            </div>
          </ModalOverlay>
        ) : null
      }
    </div>
  );
};
export default PipelineStepListContainer;
